import * as React from 'react';
import {CSSProperties, MutableRefObject, useMemo} from 'react';
import chunk from 'chunk-text';
import RBC from 'react-barcode';
import QRCode from "react-qr-code";

import {ICredencial} from "../api/ApiCredencial";
import SescLogo from "../svg/SescLogo";
import {QrCode} from "@mui/icons-material";

interface PropsHabilitacao {
    tipo?: 'qrcode' | 'barcode';
    refFoward: MutableRefObject<SVGSVGElement>;
    credencial: ICredencial;
}

export function Credencial({credencial, refFoward, tipo = 'barcode'}: PropsHabilitacao) {
    let nameY: number = 900;
    let barInfo: number = 1430;
    const _txtLg: CSSProperties = {fontSize: '3.8rem'},
        _txtMd: CSSProperties = {fontSize: '3rem'},
        _txtBold: CSSProperties = {fontWeight: 'bold'};

    let {pleno} = credencial.categoria;
    let tamanhoCategoria = credencial.categoria.nome.length;

    const {backColor, topColor} = useMemo(() => {
        return {
            backColor: pleno ? '#f7bf00' : '#dbdbdb',
            topColor: pleno ? '#facb59' : '#213267',
        };
    }, [pleno]);

    return (
        <svg version="1.1" ref={refFoward}
             xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
             id={credencial.matricula} x="0px" y="0px" viewBox="0 0 1080 1920" width={295}
             style={{fontFamily: 'sans-serif, serif, monospace', borderRadius: "4px"}} key={credencial.matricula}>
            <g>
                <clipPath id={`card-${credencial.matricula}`}>
                    <rect width="1080" height="1920"/>
                </clipPath>
                <clipPath id={`foto-${credencial.matricula}`}>
                    <circle cx="537" cy="650" r="245"/>
                </clipPath>
                <rect width="1080" height="1920" fill={backColor} clipPath={`url(#card-${credencial.matricula})`}/>
                <g>
                    <defs>
                        <rect id={`SVGID_1_${credencial.matricula}`} width="1080" height="1920"/>
                    </defs>
                    <clipPath id={`SVGID_2_${credencial.matricula}`}>
                        <use xlinkHref={`#SVGID_1_${credencial.matricula}`} style={{overflow: 'visible'}}/>
                    </clipPath>
                    <path clipPath={`url(#SVGID_2_${credencial.matricula})`} fill={topColor} d="M1060.39,420.21
			c-91.25,0-194.1,7.36-303.9,27.92c-19.87,3.71-39.97,7.87-60.27,12.48c10.19,8.16,19.72,17.09,28.53,26.69
			c132.19-31.98,254.58-48.65,355.18-55.38v-11.61C1073.47,420.25,1066.97,420.21,1060.39,420.21 M286.76,617.1
			C189.06,671.36,90.97,739.55-5.08,824.87v7.59C86.91,759.1,184.5,698.33,283.56,648.12C284,637.61,285.08,627.25,286.76,617.1"/>
                    <path clipPath={`url(#SVGID_2_${credencial.matricula})`} fill={topColor} d="M1079.93-0.56H-5.08
			v813.13c22.42-20.68,44.98-40.35,67.66-59.06c45.35-37.38,91.17-70.91,137.14-100.94c30.32-19.82,60.71-38.1,91.07-54.98
			c27.46-110.67,127.46-192.72,246.63-192.72c52.98,0,102.17,16.22,142.89,43.96c135.74-30.92,278.77-44.62,399.61-47.18V-0.56z"/>
                </g>
                <SescLogo dark={pleno} x={350} y={-750} width={380}/>
                <circle cx={537} cy={650} r={245} fill={backColor} strokeWidth={2} stroke={topColor}
                        clipPath={`url(#card-${credencial.matricula})`}/>
                <image x={292} y={385} width={490} clipPath={`url(#foto-${credencial.matricula})`}
                       href={'data:image/jpeg;base64,' + credencial.foto}/>
                {chunk(credencial.nome, 25).map((i, idx) => {
                    return <text key={idx} x="50%" y={nameY += (idx === 0 ? 120 : 70)}
                                 textAnchor="middle" style={{..._txtLg, ..._txtBold}}>{i}</text>;
                })}
                <rect x={115} y={nameY += 50} width={850} height={tamanhoCategoria>25?250:190}
                      stroke="white" fill={backColor} strokeWidth={3} rx={30}/>
                <text x="50%" y={nameY += 70} textAnchor="middle" style={{..._txtLg, ..._txtBold}}>
                    Credencial {pleno ? 'Plena' : 'Atividades'}
                </text>
                {chunk(credencial.categoria.nome, 30).map((i, idx) => {
                    return <text key={idx} x="50%"  y={nameY += 80}
                                 textAnchor="middle" style={{..._txtMd}}>{i}</text>;
                })}

                <text x="50%" y={barInfo} textAnchor="middle"
                      style={{..._txtLg, ..._txtBold}}>{credencial.matricula.replace(/[-]/g, '')}</text>
                {/*<RBC value={'1' + credencial.matricula.replace(/[-]/g, '')}*/}
                {/*     displayValue={false} height={150} width={9} background="transparent"*/}
                {/*     marginTop={barInfo += 20} marginLeft={90}/>*/}
                <QRCode
                    size={300}
                    viewBox={"0 0 256 256"}
                    value={'1' + credencial.matricula.replace(/[-]/g, '')}
                    x={390}
                    y={barInfo += 30}
                    bgColor={backColor}
                    style={{textAlign:"center"}}
                />
                <text x="50%" y={barInfo += 380} textAnchor="middle" style={{..._txtMd}}>
                    Validade {pleno ? 'Nacional' : ''}: <tspan style={{..._txtBold}}>
                    {(new Date(credencial.dtvencto)).toLocaleDateString('pt-BR', {
                        month: '2-digit',
                        year: 'numeric',
                    })}</tspan>
                </text>
                {!pleno && <text x="50%" y={barInfo + 50} textAnchor="middle" style={{..._txtMd, ..._txtBold}}>
                    Rio Grande do Norte
                </text>}
            </g>
        </svg>
    )
}